import { composeResolvers } from "@graphql-tools/resolvers-composition";
import { errorMessages, PURCHASABLE_BUFFER } from "@/lib/constants";
import { PURCHASE_ESTIMATE_ERROR_MESSAGES, VOUCHER_CODE_CHECK_ERROR_REASONS } from "@/lib/errors";
import { gql } from "@apollo/client";
import { isAuthenticated, ownerOnly, logicaErrorBody, isDateRangeIn } from "./helper";
export const typeDef = gql`
  type ProductOrder @cacheControl(scope: PRIVATE) {
    product_order_id: Int
    order: Order
    product_id: Int
    status: String
    name: String
    created_at: String
    error: String
  }

  type Order {
    order_id: Int
    payment_method_id: Int
    payment_amount: Int
  }

  type PurchaseEstimate {
    product: Product
    error: String
  }

  type Query {
    purchaseEstimate(
      productId: Int
      paymentMethodId: Int
      # userVoucherId: Int
      voucherCode: String
    ): PurchaseEstimate
  }

  type Mutation {
    purchaseExecute(
      productId: Int
      paymentInstrumentId: Int
      # userVoucherId: Int
      voucherCode: String
    ): ProductOrder
    purchaseTest(
      productId: Int
      paymentInstrumentId: Int
      voucherCode: String
      userVoucherId: Int
      mode: String
    ): ProductOrder
  }
`;
export const resolvers = composeResolvers({
  Query: {
    purchaseEstimate: async (_parent, _ref, _ref2) => {
      let {
        productId,
        paymentMethodId,
        voucherCode /*userVoucherId*/
      } = _ref;
      let {
        dataSources
      } = _ref2;
      try {
        if (voucherCode) {
          var _checkResult$voucher_;
          // purchase/estimateだと細かくエラーが出し分けられておらずエラーメッセージを場合わけして定義することができないためvoucher_codes/{code}/checkを事前にコールする
          const checkResult = await dataSources.voucherCode.check(voucherCode, {
            productId,
            paymentMethodId
          });
          // トライアル延長用のバウチャーでも適用できてしまうのでここで割引設定があるかチェックする
          if (!(checkResult !== null && checkResult !== void 0 && (_checkResult$voucher_ = checkResult.voucher_code) !== null && _checkResult$voucher_ !== void 0 && (_checkResult$voucher_ = _checkResult$voucher_.voucher) !== null && _checkResult$voucher_ !== void 0 && _checkResult$voucher_.discount_price)) {
            return {
              error: `${PURCHASE_ESTIMATE_ERROR_MESSAGES[22002]} エラーコード: 22002`
            };
          }
        }
        const res = await dataSources.purchase.estimate({
          productId,
          paymentMethodId,
          voucherCode
        });
        // if (voucherCode && userVoucherId) {
        //   // ユーザーバウチャー（放送契約割引）が渡されたらユーザーバウチャーからバウチャーの情報を取得する
        //   const userVoucher = await dataSources.user.voucher(userVoucherId);
        //   const couponVoucher = res?.voucher_code?.voucher;
        //   // バウチャーコードの割引と放送契約割引の割引価格を比較して放送契約割引の方が安かった場合はエラーにする
        //   if (userVoucher?.discount_price >= couponVoucher?.discount_price) {
        //     return { error: errorMessages["purchaseEstimateInapplicable"] };
        //   }
        // }
        return {
          product: res
        };
      } catch (e) {
        var _body$error, _body$error2;
        console.log("purchaseEstimate error", e);
        const body = logicaErrorBody(e);
        const errorCode = body === null || body === void 0 || (_body$error = body.error) === null || _body$error === void 0 ? void 0 : _body$error.code;
        const reason = body === null || body === void 0 || (_body$error2 = body.error) === null || _body$error2 === void 0 ? void 0 : _body$error2.reason_type;
        const {
          code,
          message
        } = (() => {
          var _body$error3;
          // バウチャーコードチェックAPIのバグで本来22001が返るところがnullになる
          if ((!errorCode || errorCode === 22001) && reason) {
            return VOUCHER_CODE_CHECK_ERROR_REASONS[reason];
          }
          return {
            code: errorCode,
            message: PURCHASE_ESTIMATE_ERROR_MESSAGES[errorCode] || (body === null || body === void 0 || (_body$error3 = body.error) === null || _body$error3 === void 0 ? void 0 : _body$error3.message) || errorMessages["subscriptionEstimate"]
          };
        })();
        return {
          error: `${message} エラーコード: ${code}`
        };
      }
    }
  },
  Mutation: {
    // 変更がある場合、purchaseTestCoreのロジックも同様になるよう変更する
    purchaseExecute: async (_parent, _ref3, _ref4) => {
      let {
        productId,
        paymentInstrumentId,
        voucherCode /*userVoucherId*/
      } = _ref3;
      let {
        req,
        dataSources
      } = _ref4;
      try {
        var _req$userToken;
        // Productを取得して販売期間を確認
        const product = await dataSources.product.productById({
          id: productId
        });
        const purchaseAllowed = isDateRangeIn(product === null || product === void 0 ? void 0 : product.sales_start_at, product === null || product === void 0 ? void 0 : product.sales_end_at, {
          buffer: PURCHASABLE_BUFFER,
          default: true
        });
        if (!purchaseAllowed) {
          return {
            error: "販売期間外のため購入できません。"
          };
        }
        const res = await dataSources.purchase.purchaseExecute({
          productId,
          paymentInstrumentId,
          voucherCode
          // userVoucherId,
        });
        // TODO：決済ID、ユーザーIDをログ出力する
        const userId = req === null || req === void 0 || (_req$userToken = req.userToken) === null || _req$userToken === void 0 ? void 0 : _req$userToken.id;
        console.log(`########## PurchaseExecute, userId: ${userId}, productId: ${productId} ##########`);
        console.log("purchaseExecute", res);
        console.log("########## PurchaseExecute End ##########");
        return res.product_order;
      } catch (e) {
        var _body$error4, _body$error5;
        console.log("purchaseExecute error", e);
        const body = logicaErrorBody(e);
        const errorCode = (body === null || body === void 0 || (_body$error4 = body.error) === null || _body$error4 === void 0 ? void 0 : _body$error4.code) || 500;
        const errMeesage = (body === null || body === void 0 || (_body$error5 = body.error) === null || _body$error5 === void 0 ? void 0 : _body$error5.message) || errorMessages["purchaseExecute"];
        return {
          error: `${errMeesage} エラーコード: ${errorCode}`
        };
      }
    },
    purchaseTest: async (_parent, _ref5, _ref6) => {
      let {
        productId,
        paymentInstrumentId,
        voucherCode,
        userVoucherId,
        mode = "mock"
      } = _ref5;
      let {
        req,
        dataSources
      } = _ref6;
      return purchaseTestCore(_parent, productId, paymentInstrumentId, voucherCode, userVoucherId, req, dataSources, mode);
    }
  }
}, {
  "Mutation.purchaseExecute": [isAuthenticated(), ownerOnly()]
});
async function purchaseTestCore(_parent, productId, paymentInstrumentId, voucherCode, userVoucherId, req, dataSources) {
  let mode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : "exec";
  try {
    var _req$userToken2;
    // Productを取得して販売期間を確認
    console.log("typeof datasources", typeof dataSources);
    const product = await getProductId(productId, dataSources, mode);
    const purchaseAllowed = isDateRangeIn(product === null || product === void 0 ? void 0 : product.sales_start_at, product === null || product === void 0 ? void 0 : product.sales_end_at, {
      buffer: PURCHASABLE_BUFFER,
      default: true
    });
    if (!purchaseAllowed) {
      return {
        error: "販売期間外のため購入できません。"
      };
    }
    const res = await purchaseDataSource(productId, paymentInstrumentId, voucherCode, userVoucherId, dataSources, mode);

    // TODO：決済ID、ユーザーIDをログ出力する
    const userId = req === null || req === void 0 || (_req$userToken2 = req.userToken) === null || _req$userToken2 === void 0 ? void 0 : _req$userToken2.id;
    console.log(`########## PurchaseExecute, userId: ${userId}, productId: ${productId} ##########`);
    console.log("purchaseExecute", res);
    console.log("########## PurchaseExecute End ##########");
    return res.product_order;
  } catch (e) {
    var _body$error6, _body$error7;
    console.log("purchaseExecute error", e);
    const body = logicaErrorBody(e);
    const errorCode = (body === null || body === void 0 || (_body$error6 = body.error) === null || _body$error6 === void 0 ? void 0 : _body$error6.code) || 500;
    const errMeesage = (body === null || body === void 0 || (_body$error7 = body.error) === null || _body$error7 === void 0 ? void 0 : _body$error7.message) || errorMessages["purchaseExecute"];
    return {
      error: `${errMeesage} エラーコード: ${errorCode}`
    };
  }
}
async function getProductId(productId, dataSources) {
  let mode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "exec";
  if (mode == "outdated") {
    return {
      sales_start_at: "2000-01-01 00:00:00",
      sales_end_at: "2000-01-01 23:59:59"
    };
  }
  return await dataSources.product.productById({
    id: productId
  });
}
async function purchaseDataSource(productId, paymentInstrumentId, voucherCode, userVoucherId, dataSources) {
  let mode = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "exec";
  console.log(mode);
  if (mode == "mock") {
    return await purchaseMock(productId, paymentInstrumentId, voucherCode, userVoucherId);
  }
  return await dataSources.purchase.purchaseExecute({
    productId,
    paymentInstrumentId,
    voucherCode,
    userVoucherId
  });
}

// jestで使用
async function purchaseMock(productId, paymentInstrumentId, voucherCode, userVoucherId) {
  return {
    product_order: {
      product_order_id: productId,
      order: {
        order_id: 1,
        payment_method_id: 1,
        payment_amount: 1000
      },
      product_id: 1,
      status: "purchase",
      name: "テスト商品",
      created_at: "2024-12-10 17:15:00"
    }
  };
}